import { useCallback } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { setCorporalEvaluationImageIndex } from '~/modules/corporalEvaluation/services'
import { evaluationAtom } from '~/modules/evalutation/data'
import { patchEvaluationAtom } from '~/modules/evalutation/services'

import { Mean } from './Mean'

export const MedialThighInput: React.FC = () => {
  const data = evaluationAtom.get()

  const handleUpdateField = useCallback(
    (index: number, value: string) => {
      const newArr = data ? data.medialThigh : []
      newArr[index] = +value
      patchEvaluationAtom({ medialThigh: newArr })
    },
    [data],
  )

  const handleFocus = useCallback(() => {
    setCorporalEvaluationImageIndex(3)
  }, [])

  return (
    <>
      <div className='font-bold xl:font-normal'>Coxa Medial (mm) &nbsp;</div>
      {data?.medialThigh.map((val, index) => (
        <div key={`medialThigh-${index}`}>
          <p className='block xl:hidden mb-2'>Medida {index + 1}</p>
          <MaskedInput
            value={val}
            mask='float'
            placeholder='0'
            onFocus={handleFocus}
            inputMode='numeric'
            onChange={(v) => handleUpdateField(index, v)}
          />
        </div>
      ))}
      <div>
        <p className='block xl:hidden mb-2'>Média</p>
        <Mean field='medialThigh' />
      </div>
    </>
  )
}
